// Brand Assets
export const BRAND_LOGO = "https://customer-assets.emergentagent.com/job_bhopal-luxury-1/artifacts/ev6aogco_jalsa%20retreat%20%20logo%20%281%29.png";

// Property Images
export const PROPERTY_IMAGES = {
  jalsaRetreat: {
    hero: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/kkd2nxvn_SHS_2775-Pano.jpg",
    exterior: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/h8n5y3rh_SHS_2784-Pano.jpg",
    banquet: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/xr9udpsh_Jalsa%20Retreat%20Banquet%201.jpg",
    wedding: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/xp5qhdvu_Sarovar%20Garden%20-%20taapu%201%20.png",
    sarovarGarden: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/xp5qhdvu_Sarovar%20Garden%20-%20taapu%201%20.png",
    sarovarGarden2: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/wcfegcww_Sarovar%20Garden%20-%20taapu%202.jpg",
    gym: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/0emerrw5_Gym.jpg",
    reception: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/x70jjj8a_Reception%201.jpg",
    rooms: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/na83rgs7_SHS_2463.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/6xdanoha_SHS_2488.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/jdxxcg39_1.jpg"
    ],
    suiteRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/x94886ry_SHS_2457.jpg",
    deluxeRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/dmp27j3m_SHS_2488.jpg",
    executiveRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/toliglf7_SHS_2500.jpg",
    dining: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/sh4y1oex_PHOTO-2025-06-17-18-33-11%202.jpg",
    food: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/sh4y1oex_PHOTO-2025-06-17-18-33-11%202.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/koa3atof_PHOTO-2025-06-17-18-33-14%202.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/umyl2ipt_PHOTO-2025-06-17-18-33-14%203.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/dldc08bv_PHOTO-2025-06-17-18-33-14.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/7exzu423_PHOTO-2025-06-17-18-33-16.jpg"
    ]
  },
  jalsaInn: {
    hero: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/z3jbql7q_Jalsa%20Inn%20Facade.png",
    exterior: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/z3jbql7q_Jalsa%20Inn%20Facade.png",
    rooms: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/t18zxutw_deluxe%20room.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/lcdkaeuv_Luxury%20room%201.jpg",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/kuno9d2v_Luxury%20room.jpg"
    ],
    deluxeRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/t18zxutw_deluxe%20room.jpg",
    luxuryRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/lcdkaeuv_Luxury%20room%201.jpg",
    dining: "https://images.unsplash.com/photo-1616538994032-f7619b8bebb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50JTIwZGluaW5nfGVufDB8fHx8MTc3MDQ3MzkwMnww&ixlib=rb-4.1.0&q=85"
  },
  hotelJalsa: {
    hero: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/ymimjzmi_Jalsa%20MP%20Nagar%20Facade.png",
    exterior: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/ymimjzmi_Jalsa%20MP%20Nagar%20Facade.png",
    rooms: [
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/pxbyu9uz_classic%20room%20.png",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/btazfs9o_deluxe%20room.png",
      "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/iapr40y0_Executive%20Room%201.png"
    ],
    classicRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/pxbyu9uz_classic%20room%20.png",
    deluxeRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/btazfs9o_deluxe%20room.png",
    executiveRoom: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/iapr40y0_Executive%20Room%201.png",
    lobby: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/e9lgd1oz_reception.png",
    dining: "https://images.pexels.com/photos/13674457/pexels-photo-13674457.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  common: {
    lobby: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/e9lgd1oz_reception.png",
    dining: "https://images.pexels.com/photos/239975/pexels-photo-239975.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
};

// Property Data
export const PROPERTIES = [
  {
    id: "jalsa-retreat",
    name: "Jalsa Retreat",
    tagline: "Luxury Redefined by the Lakeside",
    description: "Bhopal's flagship luxury hotel featuring lakeside gardens, the largest banquet hall, and premium accommodations for unforgettable experiences.",
    location: "Neelbad, Bhopal",
    address: "NEELBAD TIRAHA, MAIN ROAD, Bhadbhada Rd, Bhopal, Madhya Pradesh 462044",
    phone: "+91 755 422 9796",
    altPhone: "+91 90980 51796",
    email: "hoteljalsaretreat@gmail.com",
    rating: 4.5,
    reviews: 830,
    rooms: 57,
    features: [
      "Lakeside Gardens",
      "Largest Banquet Hall",
      "Wedding Venue",
      "Premium Dining",
      "Event Spaces",
      "Luxury Rooms"
    ],
    amenities: [
      "Free Wi-Fi",
      "Free Parking",
      "Restaurant",
      "Bar",
      "24-Hour Front Desk",
      "Laundry Service",
      "Event Management"
    ],
    priceRange: "₹₹₹₹",
    bookingUrl: "#"
  },
  {
    id: "jalsa-inn",
    name: "Jalsa Inn",
    tagline: "Comfort Meets Excellence",
    description: "A perfect blend of comfort and hospitality in Kolar, offering excellent service, delicious cuisine, and well-appointed rooms.",
    location: "Kolar, Bhopal",
    address: "Banjari Colony, Mahabali Nagar, Kolar Rd, Bhopal, Gehun Kheda, Madhya Pradesh 462042",
    phone: "+91 92449 41942",
    rating: 4.6,
    reviews: 283,
    features: [
      "Excellent Service",
      "Quality Dining",
      "Comfortable Rooms",
      "Family Friendly",
      "Business Facilities"
    ],
    amenities: [
      "Free Wi-Fi",
      "Free Parking",
      "Restaurant",
      "Room Service",
      "24-Hour Front Desk",
      "Housekeeping"
    ],
    priceRange: "₹₹",
    bookingUrl: "#"
  },
  {
    id: "hotel-jalsa",
    name: "Hotel Jalsa",
    tagline: "Urban Elegance in the Heart of Bhopal",
    description: "Conveniently located in MP Nagar, offering modern amenities and excellent connectivity for business and leisure travelers.",
    location: "MP Nagar, Bhopal",
    address: "233, Near Arya Bhavan, Zone-II, Maharana Pratap Nagar, Bhopal, Madhya Pradesh 462011",
    phone: "+91 755 420 8700",
    rating: 4.0,
    reviews: 387,
    features: [
      "Central Location",
      "Business Hotel",
      "Modern Amenities",
      "Restaurant",
      "Meeting Rooms"
    ],
    amenities: [
      "Free Wi-Fi",
      "Free Parking",
      "Restaurant",
      "Room Service",
      "Air Conditioning",
      "Breakfast Available"
    ],
    priceRange: "₹₹",
    bookingUrl: "https://bookingengine.stayflexi.com/hotel/google/list/23200/"
  }
];

// Color Scheme - Navy Blue, White & Gold Theme
export const COLORS = {
  primary: "#1B3A6B", // Navy Blue
  primaryDark: "#0F2847",
  primaryLight: "#2E5A8F",
  gold: "#D4AF37", // Gold
  goldDark: "#B8941F",
  goldLight: "#F4E5B8",
  secondary: "#FFFFFF", // White
  secondaryDark: "#F8F9FA",
  accent: "#8B7355", // Bronze
  background: "#FFFFFF",
  backgroundDark: "#0F0F0F",
  text: "#1A1A1A",
  textLight: "#666666",
  textOnDark: "#FFFFFF",
  textOnNavy: "#FFFFFF"
};

// Google Reviews & Testimonials
export const TESTIMONIALS = [
  {
    name: "Rahul Sharma",
    rating: 5,
    review: "One of the best hotels in Bhopal! The lakeside location is breathtaking and the banquet hall is perfect for events. Staff was extremely courteous and professional.",
    property: "Jalsa Retreat",
    date: "2 months ago"
  },
  {
    name: "Priya Verma",
    rating: 5,
    review: "Excellent food quality and service! The rooms were spacious and well-maintained. Perfect for family stays and special occasions.",
    property: "Jalsa Inn",
    date: "1 month ago"
  },
  {
    name: "Amit Patel",
    rating: 5,
    review: "Great location in MP Nagar with easy access to city center. Clean rooms, good amenities, and helpful staff. Highly recommended for business travelers.",
    property: "Hotel Jalsa",
    date: "3 weeks ago"
  },
  {
    name: "Neha Agarwal",
    rating: 5,
    review: "We hosted our wedding at Jalsa Retreat and it was absolutely magical! The lakeside garden venue was stunning and their event management team made everything perfect.",
    property: "Jalsa Retreat",
    date: "2 months ago"
  },
  {
    name: "Vikram Singh",
    rating: 5,
    review: "Exceptional hospitality! The food at the restaurant was delicious with great variety. The property is well-maintained and the ambiance is luxurious.",
    property: "Jalsa Retreat",
    date: "1 month ago"
  },
  {
    name: "Sneha Kapoor",
    rating: 4,
    review: "Very comfortable stay with excellent service. The staff went above and beyond to make our experience memorable. Will definitely visit again!",
    property: "Jalsa Inn",
    date: "2 weeks ago"
  }
];

// 101 Bar & Lounge
export const BAR_LOUNGE = {
  name: "101 Bar & Lounge",
  tagline: "The New Standard of Nightlife",
  description: "Where architecture meets mixology. Nestled within the serene Jalsa Retreat, 101 (pronounced One-O-One) is more than a lounge—it's an immersion. From our signature ceiling installations to curated spirits, we've designed every inch for the refined wanderer.",
  location: "Jalsa Retreat, Neelbad",
  features: [
    "Signature Ceiling Installations",
    "Premium Spirits Selection",
    "Curated Cocktails",
    "Expert Mixologists",
    "Stunning Marble Bar",
    "Sophisticated Ambiance"
  ],
  timings: "6:00 PM - 11:30 PM",
  contact: "+91 755 422 9796",
  images: {
    hero: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/ffwcuz4x_WhatsApp%20Image%202026-02-14%20at%208.25.41%20PM.jpeg",
    ambiance: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/fntpl2na_WhatsApp%20Image%202026-02-14%20at%208.25.42%20PM%20%281%29.jpeg",
    cocktail: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/mh703j8o_WhatsApp%20Image%202026-02-14%20at%208.25.42%20PM.jpeg",
    promo: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/iv740lo3_WhatsApp%20Image%202026-02-14%20at%208.25.41%20PM%20%282%29.jpeg"
  },
  video: "https://customer-assets.emergentagent.com/job_7f6b4518-3cb7-41cb-8ead-7fed5244d35b/artifacts/o6fd0uvp_WhatsApp%20Video%202026-02-14%20at%208.25.42%20PM.mp4"
};

// Booking Engine
export const BOOKING_ENGINE_BASE_URL = "https://bookingengine.stayflexi.com/hotel/google/list/";
